var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMultiselectDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82254 0.183573C7.58591 -0.05306 7.20366 -0.05306 6.96703 0.183573L4.00002 3.14451L1.03301 0.177505C0.796379 -0.0591276 0.414126 -0.0591276 0.177493 0.177505C-0.0591391 0.414137 -0.0591391 0.79639 0.177493 1.03302L3.1445 4.00003L0.177493 6.96704C-0.0591391 7.20367 -0.0591391 7.58592 0.177493 7.82256C0.414126 8.05919 0.796379 8.05919 1.03301 7.82256L4.00002 4.85555L6.96703 7.82256C7.20366 8.05919 7.58591 8.05919 7.82254 7.82256C8.05918 7.58592 8.05918 7.20367 7.82254 6.96704L4.85554 4.00003L7.82254 1.03302C8.05311 0.802458 8.05311 0.414138 7.82254 0.183573Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectDelete);
export default __webpack_public_path__ + "static/media/multiselect-delete.4bad6b9fa07e60a3b97c847c380e2c28.svg";
export { ForwardRef as ReactComponent };